import React from "react";
import { motion } from "framer-motion";
// import { Link } from "react-router-dom";

function CardDoctor({ doctor, t, width = null }) {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    hover: {
      y: -5,
      scale: 1.02,
      transition: { type: "spring", stiffness: 300 },
    },
  };

  const imageVariants = {
    hover: { scale: 1.1, transition: { duration: 0.3 } },
  };

  function year(datetime) {
    const date = new Date(datetime);
    const today = new Date();
    const yearsAgo = today.getFullYear() - date.getFullYear();
    return yearsAgo;
  }
  return (
    <motion.div
      variants={cardVariants}
      whileHover="hover"
      className={` h-full ${
        width ? width : "w-full"
      } mx-auto bg-white rounded-xl relative shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col `}
    >
      <div className="p-6 flex flex-col ">
        <motion.div
          variants={imageVariants}
          className=" mx-auto w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-green-100"
        >
          {doctor?.image === null ? (
            <img
              className="w-20 mx-auto mt-3 md:mt-8 h-20 object-cover"
              src={process.env.PUBLIC_URL + "/assets/user.png"}
              alt={doctor.name}
            />
          ) : (
            <img
              className="w-full h-full object-cover"
              src={process.env.REACT_APP_IMG_URL + doctor.image}
              alt={doctor.name}
            />
          )}
        </motion.div>

        <div className="mt-4  text-center h-[11.5rem]   flex flex-col  justify-between  ">
          <motion.h3
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-xl md:text-xl font-bold text-gray-800 mb-2"
          >
            
            {doctor?.name?.length > 40
              ? doctor?.name.substring(0, 40) + "..."
              : doctor?.name}
          </motion.h3>
          <div className="flex flex-col justify-between ">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-green-600 text-sm font-medium mb-4"
            >
              {doctor?.speciality?.length > 50
                ? doctor?.speciality?.substring(0, 50) + "..."
                : doctor?.speciality}
            </motion.p>
            <div className="flex justify-center gap-6 mt-4">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="text-center"
              >
                <div className="text-xl md:text-2xl font-bold text-green-700">
                  {year(doctor?.year_of_service)}+
                </div>
                <div className="text-sm text-gray-600">{t("YearExp")}</div>
              </motion.div>

              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="h-12 w-px bg-green-200"
              />

              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="text-center"
              >
                <div className="text-xl md:text-2xl font-bold text-green-700">
                  {doctor?.surgery}
                </div>
                <div className="text-sm text-gray-600">{t("surgeries")}</div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        className="h-1 bg-gradient-to-r absolute bottom-0 from-green-400 to-emerald-600"
        transition={{ duration: 0.5 }}
      />
    </motion.div>
  );
}

export default CardDoctor;
